import React from 'react';
import { range } from 'lodash';
// import { debounce } from 'lodash';

type Rating = {
  overall: number,
  coverage: number,
  accuracy: number,
  coherence: number,
  abstraction: number,
};
type Ratings = Array<Rating>;

type BookInfo = {
  info: {
    title: string,
    author: string,
    url: string,
  },
  policies: {
    [key: string]: {
      [seed: string]: {
        summary: string,
        ratings: Ratings,
      }
    }
  }

}


type Props = {
  data: Array<BookInfo>,
  set_id: (new_id: string) => void,
  data_id: string,
};
type State = {
  book_idx: number,
  model: string,
};

function average_rating(ratings: Ratings, key: keyof Rating) {
  let rt = ratings.map((x) => x[key]);
  let sum = rt.reduce((x, y)=>(x+y), 0)
  if (rt.length > 1) {
    sum = sum / rt.length;
  }
  return sum
}

const MODELS = [
  "175B full tree RL (95k labels)",
  "175B full tree RL (90k labels)",
  "175B first subtree RL (85k labels)",
  "175B first subtree RL (75k labels)",
  "175B full tree SL T=0",
  "175B full tree SL T=0.3",
  "175B full tree SL T=0.6",
  "6B full tree RL",
  "6B first subtree RL",
  "6B full tree SL T=0",
  "6B full tree SL T=0.3",
  "6B full tree SL T=0.6",
]

class GoodReads extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      book_idx: 0,
      model: MODELS[0],
    };
  }

  componentDidUpdate(prevProps: Props) {
    /*
    if (this.props.all_data.id !== prevProps.all_data.id) {
      console.log('Data changed!');
      const relevant_keys = get_relevant_keys(this.props.all_data, null);
      const newState: State = {
        ...
      } as State;
      this.setState(newState as any)
    }
     */
  }

  updateState(update: any) {
    this.setState(update);
    console.log('update', update);
  }

  handleStateChange(key: string, event: any) { // KeyboardEvent
    const update: any = {};
    update[key] = event.target.value;
    this.updateState(update);
  }

  showError(err: any) {
    // TODO: better
    console.error(err);
    alert(err);
  }
  render() {
    const book_data = this.props.data;
    const book_info = book_data[this.state.book_idx];
    // this.updateState(update);
    return (
      <div>
        Book <select
          value={this.state.book_idx}
          onChange={(ev) => {
            this.updateState({book_idx: parseInt(ev.target.value)})
          }}
        >
          {
            book_data.map((other_book_info, id) => {
              return <option key={id} value={id}>{other_book_info.info.title} (by {other_book_info.info.author})</option>
            })
          }
        </select>
        <br/>

        Model <select
          value={this.state.model}
          onChange={(ev) => {
            this.updateState({model: ev.target.value})
          }}
        >
          {
            MODELS.map((model) => {
              return <option key={model} value={model}>{model}</option>
            })
          }
        </select>

        <h4>
          <a href={book_info.info.url}>
          {book_info.info.title}
          </a>
        </h4>
        <h5>
          by {book_info.info.author}
        </h5>
        <div className={""/*"flex-container"*/}>
          {
            [
              {policy: 'Human 1', seed: '0', display: 'Human 1 summary'},
              {policy: 'Human 2', seed: '0', display: 'Human 2 summary'},
              {policy: this.state.model, seed: '1', display: 'Model summary 1'},
              {policy: this.state.model, seed: '2', display: 'Model summary 2'},
              {policy: this.state.model, seed: '3', display: 'Model summary 3'},
            ].map((to_display) => {
              const contents = book_info.policies[to_display.policy][to_display.seed];
              return (
                <div key={to_display.policy + "." + to_display.seed}>
                  <h4>
                    {to_display.display}
                  </h4>
                  <div className="flex-container">
                    <div className="treecontent" style={{flexBasis: 0, flexGrow: 1}}>
                      {contents.summary}
                    </div>
                    <div style={{flexBasis: '150px', flexGrow: 0}}>
                      <h5>Ratings</h5>
                      Overall: {average_rating(contents.ratings, 'overall').toFixed(1)}
                      <br/>
                      Accuracy: {average_rating(contents.ratings, 'accuracy').toFixed(1)}
                      <br/>
                      Coverage: {average_rating(contents.ratings, 'coverage').toFixed(1)}
                      <br/>
                      Coherence: {average_rating(contents.ratings, 'coherence').toFixed(1)}
                      <br/>
                      Abstraction: {average_rating(contents.ratings, 'abstraction').toFixed(1)}
                    </div>
                  </div>
                </div>
              );
            })
          }

          {/*JSON.stringify(book_info.policies)*/}
        </div>
      </div>
    );
  }
}

export default GoodReads;

